import React, { PureComponent } from 'react';
import { connect } from '../../../../../../redux/connect';
import {
  getCurrentViewType,
} from '../../../../../../redux/selectors';
import TitleInlineEdit from './components/TitleInlineEdit';
import { issueAttributesType } from '../../../../../../constants/proptype-validation';
import PropTypes from 'prop-types';
import { viewTypes } from '../../../../../../constants/view-types';
import classNames from 'classnames';
import IssueFieldInlineEdit from '../../../../../IssueFieldInlineEdit';

export class PureIssuePreviewDetailsTabTitleSection extends PureComponent {

  render() {
    const { issue, viewType } = this.props;

    const formClassNames = classNames('IssuePreviewDetailsTabTitleSection', {
      'IssuePreviewDetailsTabTitleSection__narrow': viewType === viewTypes.DOCUMENT,
      'IssuePreviewDetailsTabTitleSection__wide': viewType === viewTypes.PROJECT,
    });
    const inlineEditStyleType = viewType === viewTypes.DOCUMENT ? IssueFieldInlineEdit.StyleTypes.SMALL : IssueFieldInlineEdit.StyleTypes.DEFAULT;
    return (
      <form className={formClassNames}>
        {/* Title */}
        <TitleInlineEdit
          issue={issue}
          styleType={inlineEditStyleType}
        />
      </form>
    );
  }
}

PureIssuePreviewDetailsTabTitleSection.displayName = 'IssuePreviewDetailsTabTitleSection';

PureIssuePreviewDetailsTabTitleSection.propTypes = {
  issue: issueAttributesType.isRequired,
  viewType: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  viewType: getCurrentViewType(state),
});

export default connect(mapStateToProps)(PureIssuePreviewDetailsTabTitleSection);

